'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDollarsPerHour = exports.formatDollars = exports.formatCentsToDollars = exports.dollarsToCents = exports.centsToDollars = undefined;

var _big = require('big.js');

var _big2 = _interopRequireDefault(_big);

var _round = require('../round');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberWithCommas = function numberWithCommas(number) {
  return new _big2.default(number).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var centsToDollars = exports.centsToDollars = function centsToDollars(cents) {
  return (0, _round.roundToTwoDecimalPlaces)(new _big2.default(cents / 100));
};

var dollarsToCents = exports.dollarsToCents = function dollarsToCents(dollars) {
  return (0, _round.roundToZeroDecimalPlaces)(new _big2.default(dollars * 100));
};

var formatCentsToDollars = exports.formatCentsToDollars = function formatCentsToDollars(cents) {
  return '$' + numberWithCommas(centsToDollars(cents));
};

var formatDollars = exports.formatDollars = function formatDollars(dollars) {
  return '$' + numberWithCommas(dollars);
};

var formatDollarsPerHour = exports.formatDollarsPerHour = function formatDollarsPerHour(dollarsPerHour) {
  return formatDollars(dollarsPerHour) + '/hr';
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/currency/index.js
// module id = 579
// module chunks = 0